module.exports = __webpack_public_path__ + "img/20191217162351360截图20191217101345089.27f92a83.jpg";